import {
  Atom,
  CodeBlock,
  HeadCircuit,
  Images,
  ListMagnifyingGlass,
  PencilLine,
  Video,
} from '@phosphor-icons/react';
import { SortOrder, QuickSkillCommandType, QuickSkillCommand } from 'src/types';
import { getMessageKey } from 'src/utils';

export const DEFAULT_NUMBER_OF_REFERENCES = 3;
export const DEFAULT_REFERENCE_WIDTH = 200;
export const DEFAULT_REFERENCE_HEIGHT = 112;
export const RESEARCH_STREAMING_SPEED = 5;
export const SCROLLER_PAUSE_TIME = 350;
export const DEFAULT_SCROLLER_THRESHOLD = 100;
export const DEFAULT_STREAMING_SPEED = 2;
export const DEFAULT_CHAT_NAME = 'new-chat';
export const DEFAULT_CHAT_ID = 'default';
export const DEFAULT_PAGE_LIMIT = 100;
export const DEFAULT_SORT_ORDER = SortOrder.DESC;

export const TEMPORARY_CONVERSATION_ID = 'new-chat';
export const TEMPORARY_MESSAGE_ID = 'new-message';

export const DEFAULT_GUEST_TAG = '[@guest]';
export const TAGS_TO_REPLACE = [DEFAULT_GUEST_TAG];

export const MESSAGE_KEY = getMessageKey();

/**
 * @deprecated
 */
export const CommunicationStyle: Record<number, string> = {
  1: 'Concise',
  2: 'Brief',
  3: 'Moderate',
  4: 'Detailed',
  5: 'Verbose',
};

export const CITATION_REGEX = / ?\[citation:(\d+)\]/g;
export const CITATION_REGEX_WITHOUT_SPACE = /\[citation:(\d+)\]/g;
export const CITATION_TITLE_REGEX = /^citation:(\d+)$/;

export const FILE_REGEX =
  /---\[original-filename="([^"]+)" converted-filename="([^"]+)"\]---/;
export const EDIT_FILE_REGEX = /---\[edit-image-url="([^"]+)"\]---/;

export const AttachmentFileInputId = 'attachFile';

export const MAX_NUMBER_OF_WORDS = 16000;
export const MAX_NUMBER_OF_PASTED_WORDS = 16000;
export const MAX_NUMBER_OF_WORDS_OPEN_TIER = 2000;

export const CONVERTED_TEXT_TO_FILE_NAME = 'InputPrompt.txt';
export const CONVERTED_PASTED_TEXT_TO_FILE_NAME = 'Pasted';
export const CONVERTED_TEXT_TO_FILE_EXTENSION = '.txt';

export enum PromptLoadingReason {
  UNDEFINED = 'undefined',
  IMPROVING = 'improving',
  TRANSLATING = 'translating',
}

/**
 * @deprecated
 */
export const CODE_WITHOUT_NEWLINE_REGEX = /(\\n)?\s*```/g;
/**
 * @deprecated
 */
export const CODE_LANGUAGE_REGEX = /```(\w+)?\n([\s\S]*?)```/g;

// it's a code duplication. needs refactoring
export const QUICK_SKILL_COMMANDS: QuickSkillCommandType[] = [
  {
    skill: QuickSkillCommand.IMAGE,
    title: 'Image',
    description: 'Create & edit images',
    Icon: Images,
  },
  {
    skill: QuickSkillCommand.CODER,
    title: 'Write/Code',
    description: 'Create & debug code',
    Icon: CodeBlock,
  },
  {
    skill: QuickSkillCommand.RESEARCHER,
    title: 'Fast Search',
    description: 'Online fast research',
    Icon: ListMagnifyingGlass,
  },
  {
    skill: QuickSkillCommand.DEEP_RESEARCHER,
    title: 'Deep Research',
    description: 'Online deep research',
    Icon: Atom,
    isLimited: true,
  },
  {
    skill: QuickSkillCommand.WRITER,
    title: 'Write/Code',
    description: 'Write, brainstorm, get advice',
    Icon: PencilLine,
  },
  {
    skill: QuickSkillCommand.FILE,
    title: 'File Analysis',
    description: 'Analyze file attachments for insights',
    Icon: PencilLine,
  },
  {
    skill: QuickSkillCommand.VIDEO,
    title: 'Video',
    description: 'Create video',
    Icon: Video,
  },
  {
    skill: QuickSkillCommand.THINKING,
    title: 'Thinking',
    description: 'Step-by-step problem solving',
    Icon: HeadCircuit,
  },
];

export const SKILL_COMMANDS_AS_TOGGLE = [
  QuickSkillCommand.IMAGE,
  QuickSkillCommand.RESEARCHER,
  QuickSkillCommand.DEEP_RESEARCHER,
  QuickSkillCommand.WRITER,
  QuickSkillCommand.THINKING,
];
